<script lang="ts">
  import type { Duration } from 'dayjs/plugin/duration';
  import { onMount } from 'svelte';

  import { dayjs } from '@utils/timestamps';

  import { timerWorkerScript } from './timer-worker';

  import type { Dayjs } from 'dayjs';

  export let from: number;
  export let dateFormat = 'YYYY-MM-DD HH:mm:ss';
  export let onDone: (() => void) | undefined = undefined;

  let remaining = {
      years: 0,
      months: 0,
      weeks: 0,
      days: 0,
      hours: 0,
      minutes: 0,
      seconds: 0,
      done: true,
  };

  let diff = 0;
  let r: Duration;
  let target: Dayjs;
  let local: Dayjs;
  let timer: ReturnType<typeof setInterval>;

  function updateRemaining(diffMs: number, dur: Duration) {
      if (diffMs > 0) {
          remaining = {
              years: dur.years(),
              months: dur.months(),
              weeks: dur.weeks(),
              days: dur.days(),
              hours: dur.hours(),
              minutes: dur.minutes(),
              seconds: dur.seconds(),
              done: false,
          };
      } else {
          remaining = {
              years: 0,
              months: 0,
              weeks: 0,
              days: 0,
              hours: 0,
              minutes: 0,
              seconds: 0,
              done: true,
          };
      }
  }

  onMount(() => {
      try {
          target = dayjs(from, dateFormat);
      } catch (e) {
          target = dayjs(from, dateFormat);
          console.warn('Could not calculate date, make sure your "from" and "dateFormat" inputs are correct.');
      }

      if (dayjs.isDayjs(target)) {
          local = dayjs();
          diff = target.valueOf() - local.valueOf();
      }

      r = dayjs.duration(diff);
      updateRemaining(diff, r);

      if (Worker) {
          const worker = new Worker(timerWorkerScript);
          worker.postMessage({ duration: diff });

          worker.addEventListener('message', (event: MessageEvent) => {
              const data = event.data;

              if (data.diff === undefined) {
                  return;
              }

              r = dayjs.duration(data.diff);
              updateRemaining(data.diff, r);

              if (data.isFinished && onDone) {
                  onDone();
              }
          });
      } else {
          timer = setInterval(function () {
              if (diff > 0) {
                  r = dayjs.duration(diff);
                  updateRemaining(diff, r);
                  diff -= 1000;
              } else {
                  updateRemaining(diff, r);
                  clearInterval(timer);

                  if (onDone) {
                      onDone();
                  }
              }
          }, 1000);
      }
  });
</script>

<slot {remaining}></slot>